module.exports = __webpack_public_path__ + "img/logo.70ebb211.svg";